/**
 * Signature re-capture — success screen (PF-6119)
 *
 * Screen 3 of `/signature-recapture/:recaptureId`. No back, no forward — the flow ends here, and by
 * the time it renders the signature is stored and every affected course has been patched and
 * regenerated, so "du musst nichts weiter tun" is literally true.
 */
import Lottie from 'react-lottie';
import styled from 'styled-components';
import successAnimation from '../../../assets/lotties/SuccessCheck.json';
import { space } from '../../../styles/onboardingUiTokens';
import { signatureRecaptureCopy } from '../config/copy';
import { Body, H1, OnboardingBody, OnboardingFooter, OnboardingHeader, OnboardingLayout } from '../ui';

const copy = signatureRecaptureCopy.success;

export type SuccessScreenProps = {
  firstName: string;
};

const lottieOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimation,
  rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
};

export function SuccessScreen({ firstName }: SuccessScreenProps) {
  return (
    <OnboardingLayout currentStep={3} totalSteps={3} hideForward>
      <OnboardingHeader hideBackButton hideProgress />
      <OnboardingBody disableSupportHint>
        <ContentStack>
          <LottieWrapper>
            <Lottie options={lottieOptions} height={200} width={200} isClickToPauseDisabled />
          </LottieWrapper>
          <H1>{copy.title.replace('{firstName}', firstName)}</H1>
          <Body variant="document">{copy.body}</Body>
        </ContentStack>
      </OnboardingBody>
      <OnboardingFooter hidePrivacyNote />
    </OnboardingLayout>
  );
}

const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${space.lg};
  padding-bottom: ${space.xl};
`;

const LottieWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
